<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" aria-hidden="true">
    <path
      d="M12 3 2.75 19h18.5L12 3Z"
      class="stroke-current"
      stroke-width="1.8"
      stroke-linejoin="round"
    />
    <path
      d="M12 8.5v5M12 16.5v.25"
      class="stroke-current"
      stroke-width="1.8"
      stroke-linecap="round"
    />
  </svg>
</template>